import { useEffect } from 'react';

// Marca inert (oculto e inalcanzable por teclado/lector de pantalla) el contenido de página
// detrás de un overlay mobile a pantalla completa (DrawerMas, CampanaUnificada) mientras está
// abierto. El contenido de página no es descendiente del componente que abre el overlay — vive
// como hermano de la navegación dentro de .main-layout (ver components/MainLayout.js) — por eso
// se referencia por selector en vez de por ref/prop.
export default function useInertFondo(activo) {
    useEffect(() => {
        if (!activo) return;
        const contenido = document.querySelector('.main-layout > .container');
        if (!contenido) return;

        contenido.inert = true;
        return () => {
            contenido.inert = false;
        };
    }, [activo]);
}
